export enum InventoryEvents {
    userAddedProductToInventory = 'user_added_product_to_inventory',
    userAddedShoeToInventory = 'user_added_shoe_to_inventory',
    userAddedNailToInventory = 'user_added_nail_to_inventory',
    userAddedCustomProductToInventory = 'user_added_custom_product_to_inventory',
    userAddedRaspToInventory = 'user_added_rasp_to_inventory',
    userChangedProductAmountInInventory = 'user_changed_product_amount_in_inventory',
}
